import { useTranslation } from "react-i18next";
import { Icons } from "../../../Everou/_assets";

// Shown once above the integrations catalog: template edits reach every
// integration of the active scope, not just the location you are looking at.
// The scope itself (organization or personal) is already named by the selector
// right above, so this only states the effect.
export function PMSAccountScopeInfoBanner() {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-center c-bg-grey-250 c-rounded-big p-3 mb-2">
            <img
                src={Icons.info}
                alt="info"
                className="mr-2 flex-shrink-0"
                style={{ width: "24px", height: "24px" }}
            />
            <span>{t("mod_integrations_template_scope_info_apply")}</span>
        </div>
    );
}
